<div class="lum-modal client-profile-dialog__modal-wrapper">
  <div class="lum-modal__header justify-space-between w-p100 mb-6">
    <span class="lum-modal__header-title flex text-large">Send Purchase Order</span>
  </div>
</div>

<div class="lum-modal__body">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label class="lum-label">Search to add contact</label>
      </div>
    </div>
  </div>

  <lum-ui-autocomplete
    placeholder="Search Contact"
    [debounceTime]="500"
    [options]="contacts"
    [displayProperty]="'contactName'"
    (inputChangeEvent)="onChangeContactEvent($event)"
    (optionSelectedEvent)="onSelectContactEvent($event)"
  ></lum-ui-autocomplete>

  <!-- list added contacts here  -->
  <div class="contact-list mt-4" [formGroup]="contactsForm">
    <div formArrayName="contacts">
      <ng-container
        *ngFor="let contactControl of contactsControl.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="d-block">
          <mat-checkbox formControlName="selected">
            <span class="contact-name mr-1">{{
              contactControl.value.contact_name
            }}</span>
            <span class="contact-email"
              >[{{ contactControl.value.contact_email }}]</span
            >
          </mat-checkbox>
        </div>
      </ng-container>
    </div>
  </div>

  <hr />
  <div class="lum-modal__footer">
    <div class="d-flex justify-content-end lum-modal__action">
      <button
        type="button"
        class="lum-button lum-button--secondary mr-2"
        mat-button
        (click)="onClose()"
      >
        Close
        <i class="far fa-times-circle"></i>
      </button>

      <button
        type="button"
        class="lum-button"
        mat-button
        [disabled]="loading"
        (click)="onSubmit()"
      >
        Send
        <i class="far fa-paper-plane"></i>
      </button>
    </div>
  </div>
</div>
